/**
 * =============================================================
 * AADHAV ACADEMY – ADMIN FEE MASTER API
 * Role: Admin
 * Scope: Tenant-based fee structures and templates
 * Standard: Enterprise / MNC Level
 * =============================================================
 */

import { apiCall } from "../core/apiCall";

const FEE_MASTER_ENDPOINT = "/admin/fees/fee_master.php";

/**
 * GET – Fetch Active Fee Masters / Templates
 */
export const getFeeMasters = async (options = {}) => {
  try {
    const res = await apiCall(
      "GET",
      FEE_MASTER_ENDPOINT,
      null,
      "Admin – Fetch Fee Masters",
      options
    );

    if (!res || res.status !== true) {
      return {
        success: false,
        message: res?.message || "Failed to fetch fee templates",
        data: [],
      };
    }

    return {
      success: true,
      data: res.data || [],
    };
  } catch (error) {
    console.error("Admin Fetch Fee Masters Error:", error);
    return {
      success: false,
      message: error.message || "Unexpected error occurred",
      data: [],
    };
  }
};